(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dome-drop-alert"] && !Shopify.designMode) return;
  try {
    class DomeDropAlert extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      this.closest('article').addEventListener('click', event => {
        const trigger = event.target.closest('[data-drop-alert-open]');
        if (!trigger) return;
        this.opener = trigger;
        dialog.showModal();
      }, options);
      this.querySelector('[data-drop-alert-close]').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('dome-drop-alert')) customElements.define('dome-drop-alert', DomeDropAlert);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dome-size-guide"] && !Shopify.designMode) return;
  try {
    class DomeSizeGuide extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-dome-size-guide]');
        if (!trigger || this.dialog.open) return;
        this.opener = trigger;
        this.dialog.showModal();
      }, options);
      this.querySelector('[data-size-guide-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() { this.controller.abort(); }
  }
  if (!customElements.get('dome-size-guide')) customElements.define('dome-size-guide', DomeSizeGuide);
  } catch(e) { console.error(e); }
})();

})();
